module.exports = __webpack_public_path__ + "static/media/AtlasGrotesk-RegularItalic-Cy-Web.e0ab2453.woff2";